module.exports = __webpack_public_path__ + "img/ProvincieOverijssel.6b301951.png";